// "use client";
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { IoExitOutline } from "react-icons/io5";
// import socket from "../socket";
// import { useRole } from "../store";

// function Navbar() {
//   const navigate = useNavigate();
//   const setIsMonitor = useRole((state)=>state?.setIsMonitor)

//   const handleLogout = () => {
//     localStorage.removeItem('user_token');
//     navigate('/login');
//     setIsMonitor(false);
//     socket.removeAllListeners();
//     socket.disconnect();
//     socket.off();
//   };

//   return (
//     <nav className="main-header navbar navbar-expand navbar-white navbar-light px-2">
//       <ul className="navbar-nav d-flex align-items-center justify-content-between w-100">
//         <li className="nav-item">
//           <Link className="nav-link" data-widget="pushmenu" href="#" role="button">
//             <i className="fas fa-bars" />
//           </Link>
//         </li>
//         <li className="nav-item">
//           <button className='btn btn-danger ' onClick={handleLogout}>
//             <span className='pe-2'>Logout</span>
//             <IoExitOutline className='fs-5' />
//           </button>
//         </li>
//       </ul>
//     </nav>
//   );
// }

// export default Navbar;

"use client";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoExitOutline } from "react-icons/io5";
import { MdDashboard } from "react-icons/md";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { MdArrowDropDown } from "react-icons/md";
import { IoMdChatboxes } from "react-icons/io";
import socket from "../socket";
import { useRole } from "../store";

function Navbar() {
  const navigate = useNavigate();
  const setIsMonitor = useRole((state) => state?.setIsMonitor);
  const isMonitor = useRole((state) => state?.isMonitor);
  const { pathname } = useLocation();
  const [active, setActive] = useState("");

  // Set the active link based on the current path
  useEffect(() => {
    const currentPath = pathname.split("/")[1];
    setActive(currentPath);
  }, [pathname]);

  // Handle user logout
  const handleLogout = () => {
    localStorage.removeItem("user_token");
    setIsMonitor(false);
    socket.removeAllListeners();
    socket.disconnect();
    navigate("/login");
  };


  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white px-3 d-lg-block d-none">
        <div className="container-fluid">
          {/* Logo or Brand */}
          <Link to="/" className="navbar-brand fw-bold text-black me-4">
            User Panel
          </Link>

          {/* Navbar toggle for small screens */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            {/* Navigation Links */}
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {isMonitor ? (
                <li className="nav-item">
                  <Link
                    to="/"
                    className={`nav-link fw-semibold ${active === ""
                      ? "text-primary fw-bold border-bottom border-2 border-primary"
                      : "text-black"
                      }`}
                  >
                    <MdOutlineDashboardCustomize className="me-1" />
                    Monitor Dashboard
                  </Link>
                </li>
              ) : <li className="nav-item">
                <Link
                  to="/"
                  className={`nav-link fw-semibold ${active === ""
                    ? "text-primary fw-bold border-bottom border-2 border-primary"
                    : "text-black"
                    }`}
                >
                  <MdDashboard className="me-1" />
                  Dashboard
                </Link>
              </li>}
              <li className="nav-item">
                <Link
                  to="/chat-box/campaigns"
                  className={`nav-link fw-semibold ${active === "chat-box"
                    ? "text-primary fw-bold border-bottom border-2 border-primary"
                    : "text-black"
                    }`}
                >
                  <IoMdChatboxes className="me-1" />
                  Chat Box
                </Link>
              </li>
              <li className="nav-item dropdown">
                <a
                  className={`nav-link dropdown-toggle fw-semibold ${active === "report"
                    ? "text-primary fw-bold border-bottom border-2 border-primary"
                    : "text-black"
                    }`}
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Reports
                  <MdArrowDropDown className="fs-5 ps-1" />
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown" style={{ maxHeight: 350, overflow: "hidden", overflowY: "auto" }}>
                  {
                    isMonitor && (
                      <>
                        <Link className="dropdown-item" to="/report/agent-wise">
                          Agent-wise Unique <br />Customer Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/sms-conversion">
                          SMS Conversion Report
                        </Link>
                        {/* <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/sms-conversion-report/campaign-list">
                          SMS Conversion Report - 2
                        </Link> */}
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/campaign-wise/campaign-list">
                          Campaign Wise Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/custom">
                          Custom Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/customer-wise/campaign-list">
                          Customer Wise Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/incoming-outgoing/campaign-list">
                          Incoming & Outgoing Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/day-wise/campaign-list">
                          Day Wise Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/agent-wise-day-month/campaign-list">
                          Agent Wise (D-W-M) Report
                        </Link>
                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/report/disposition-status/campaign-list">
                          Disposition Status Report
                        </Link>
                        <div className="dropdown-divider"></div>
                      </>
                    )
                  }
                  <Link className="dropdown-item" to="/report/history">
                    SMS History Report
                  </Link>
                  <div className="dropdown-divider"></div>
                  <Link className="dropdown-item" to="/report/one-to-one/campaign-list">
                    One To One Report
                  </Link>
                </div>
              </li>
            </ul>

            <li className="nav-item list-unstyled">
              <button className="btn btn-danger" onClick={handleLogout}>
                <span className="pe-2">Logout</span>
                <IoExitOutline className="fs-5" />
              </button>
            </li>
          </div>
        </div>
      </nav>

      <nav className="main-header navbar navbar-expand navbar-white navbar-light px-2 d-lg-none">
        <ul className="navbar-nav d-flex align-items-center justify-content-between w-100">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item">
            <button className="btn btn-danger" onClick={handleLogout}>
              <span className="pe-2">Logout</span>
              <IoExitOutline className="fs-5" />
            </button>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default Navbar;
